import * as React from 'react';
export const IcPinOff = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12.71 7.05L8.24 2.59a2 2 0 00-2.83 0L2.59 5.41a2 2 0 000 2.83l4.46 4.47 5.66-5.66zm2.62 6.84l3.79-3.79a1.5 1.5 0 00-1.06-2.56h-.15L20.49 5a1.055 1.055 0 00-1.148-1.718c-.128.053-.244.13-.342.228L3.51 19A1.054 1.054 0 105 20.49l2.58-2.58v.15a1.5 1.5 0 002.56 1.06l3.79-3.79L19 20.49A1.054 1.054 0 1020.49 19l-5.16-5.11z'
      fill='currentColor'
    />
  </svg>
);
